import { Location } from '@angular/common';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NonceUtility } from '@jms/model';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';
import { UtilService } from '@jms/utils/util.services';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { v7 } from 'uuid';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

    constructor(private location: Location) { }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {

        let effectiveRequest = req;

        const environmentNonce = ConfigService.environment.nonce;
        const tenant = ConfigService.environment.tenant;
        const hostname = window.location.hostname;
        const nonce = NonceUtility.tryGenerate(tenant, hostname, environmentNonce);

        if (nonce) {
            effectiveRequest = req.clone({ headers: req.headers.append('Nonce', nonce) });
        }

        const existingCorrelationId = req?.headers?.get('X-CorrelationId');

        if (!existingCorrelationId) {
            effectiveRequest = effectiveRequest.clone({ headers: effectiveRequest.headers.append('X-CorrelationId', v7()) });
        }

        // const nonce = ConfigService?.environment?.nonce;
        // let key;
        // if (nonce?.length) {
        //     try {
        //         const [, , extractedKey] = nonce.split('.');
        //         key = extractedKey;
        //     } catch (error) {

        //     }
        // } else {
        //     key = NonceUtility.hash('portal')
        // }

        // if (key) {
        //     const nonce = NonceUtility.encrypt(`${ConfigService?.environment?.tenant}:${window?.location?.hostname}:${Date.now() + 15_000}`, key);
        // }


        return next
            .handle(effectiveRequest).
            pipe(
                catchError(err => this.handleError(err))
            );
    }

    private handleError(err: HttpErrorResponse): Observable<any> {
        if (err.status === 401 || err.status === 403) {
            const url = ConfigService.environment.jms.logoutHref;
            UtilService.navigate(url, `${ConfigService.origin}${this.location.path()}`);
            return of(err.message);
        }

        return throwError(err);
    }
}
